import {DataType} from '../../../../../../../shared/types/form.types';

export const DATA_TYPE_OPTIONS = [
  {label: 'Число', value: DataType.Number},
  {label: 'Строка', value: DataType.String},
  {label: 'Дата', value: DataType.Date},
  {label: 'Штрихкод', value: DataType.Barcode},
  {label: 'Файл', value: DataType.File},
  {label: 'Мультивыбор', value: DataType.Multiple},
];
